import { HStack, NormalButton, Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

export interface PurchaseHistoryCardProps {
  className?: string;
  brandName: string;
  productName: string;
  imageUrl: string;
  /** 옵션(사이즈) 명 - option_item_name 매핑 */
  optionItemName?: string | null;
  actionButtonText: string;
  actionButtonVariant?: 'primary' | 'tertiary';
  isSelected: boolean;
  onCompareClick: () => void;
  onProductClick?: () => void;
  productInfoWidth?: number;
  /** 1개일 때 전체 너비를 채우도록 설정 */
  isFilled?: boolean;
}

export const PurchaseHistoryCard = ({
  className,
  brandName,
  productName,
  imageUrl,
  optionItemName,
  actionButtonText,
  actionButtonVariant = 'primary',
  isSelected,
  onCompareClick,
  onProductClick,
  productInfoWidth,
  isFilled = false,
}: PurchaseHistoryCardProps) => {
  return (
    <CardContainer className={className} isFilled={isFilled}>
      <ProductInfoWrapper onClick={onProductClick} width={productInfoWidth}>
        <HStack>
          <img src={imageUrl} alt={productName} style={{ width: 64, height: 64, objectFit: 'cover' }} />
        </HStack>

        <MetadataSection>
          <BrandName variant='Caption_12_SemiBold' color='textPrimary'>
            {brandName}
          </BrandName>
          <ProductName variant='Caption_12_Regular' color='textPrimary'>
            {productName}
          </ProductName>
          {optionItemName && (
            <OptionItemName variant='Caption_11_Regular' color='textSecondary'>
              {optionItemName}
            </OptionItemName>
          )}
        </MetadataSection>
      </ProductInfoWrapper>

      <ActionSection>
        <NormalButton size='small' variant={actionButtonVariant} onClick={onCompareClick} disabled={isSelected}>
          {actionButtonText}
        </NormalButton>
      </ActionSection>
    </CardContainer>
  );
};

const CardContainer = styled.div<{ isFilled?: boolean }>`
  display: flex;
  width: ${({ isFilled }) => (isFilled ? '100%' : 'calc(100vw - 55px)')};
  max-width: ${({ isFilled }) => (isFilled ? 'none' : '388px')};
  height: 88px;
  border-radius: 6px;
  border: 1px solid ${vars.color.borderPrimary};
  padding: 12px;
  margin-right: ${({ isFilled }) => (isFilled ? '0' : '8px')};
  flex-shrink: 0;
  align-items: center;
  flex-direction: row;

  &:last-child {
    margin-right: 0;
  }
`;

const MetadataSection = styled.div`
  flex: 1;
  min-width: 0;
  margin-left: 12px;
  margin-right: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const OptionItemName = styled(Text)`
  width: 100%;
  overflow: hidden;
  color: var(--zds-color-semantic-text-secondary);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  font-family: var(--Typography-Family-Pretendard, Pretendard);
  font-size: var(--Typography-Size-Caption_11, 11px);
  font-style: normal;
  font-weight: var(--Typography-Weight-Regular, 400);
  line-height: normal;
`;

const BrandName = styled(Text)`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  margin-bottom: 4px;
`;

const ProductName = styled(Text)`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  margin-bottom: 4px;
`;

const ActionSection = styled.div`
  flex-shrink: 0;
`;

const ProductInfoWrapper = styled.div<{ width?: number }>`
  display: flex;
  flex: ${({ width }) => (width ? 'none' : 1)};
  width: ${({ width }) => width && `${width}px`};
  align-items: center;
  min-width: 0;
  cursor: pointer;
`;
